/** Sdílené kousky modulu Checklisty. */
export const SECTION_COLOR = '#0CC0DF';
export const SECTION_BG = 'rgba(12,192,223,0.12)';
export const STAV_BARVY = { otevreno: '#F59E0B', probihajici: '#3B82F6', dokonceno: '#10B981', preruseno: '#6B7280' };
export const STAV_LABELS = { otevreno: 'Otevřeno', probihajici: 'Probíhá', dokonceno: 'Dokončeno', preruseno: 'Přerušeno' };
export const TYP_BODU = { lednice: 'Lednice', mrazak: 'Mrazák', meridlo: 'Měřidlo', jine: 'Jiné' };
export const TYP_POLOZKY = { checkbox: 'Úkol', kontrola: 'Kontrola OK/NOK', cislo: 'Měření', vyber: 'Výběr', foto: 'Foto', text: 'Text' };

export function csrf() { return document.querySelector('meta[name="csrf-token"]')?.content; }
export const hlavicky = () => ({ 'Content-Type': 'application/json', Accept: 'application/json', 'X-CSRF-TOKEN': csrf() });
export const cislo = (v) => v == null ? '—' : Number(v).toLocaleString('cs-CZ', { maximumFractionDigits: 3 });
export const kdy = (iso) => iso ? new Date(iso).toLocaleString('cs-CZ', { day: 'numeric', month: 'numeric', hour: '2-digit', minute: '2-digit' }) : '';

export function Badge({ children, color, bg }) {
    return <span style={{ fontSize: 10, fontWeight: 600, padding: '2px 8px', borderRadius: 999, background: bg || `${color}18`, color, border: `1px solid ${color}30`, lineHeight: '16px', display: 'inline-block', whiteSpace: 'nowrap' }}>{children}</span>;
}

/** Mini trend (sparkline) s pásmem limitu. */
export function Trend({ rada = [], min = null, max = null, barva = SECTION_COLOR, vyska = 24, sirka = 90 }) {
    if (rada.length < 2) return <svg width={sirka} height={vyska} aria-hidden="true" />;
    const h = rada.map(r => r.h);
    let lo = Math.min(...h), hi = Math.max(...h);
    if (min != null) lo = Math.min(lo, min);
    if (max != null) hi = Math.max(hi, max);
    const roz = hi - lo || 1;
    const y = (v) => vyska - 2 - ((v - lo) / roz) * (vyska - 4);
    const x = (i) => (i / (rada.length - 1)) * sirka;
    return (
        <svg width={sirka} height={vyska} viewBox={`0 0 ${sirka} ${vyska}`} aria-hidden="true" style={{ flexShrink: 0, display: 'block' }}>
            {(min != null || max != null) && <rect x="0" y={max != null ? y(max) : 0} width={sirka} height={Math.max(1, (min != null ? y(min) : vyska) - (max != null ? y(max) : 0))} fill="rgba(16,185,129,0.12)" />}
            <polyline points={rada.map((r, i) => `${x(i)},${y(r.h)}`).join(' ')} fill="none" stroke={barva} strokeWidth="1.6" />
            {rada.map((r, i) => r.x ? <circle key={i} cx={x(i)} cy={y(r.h)} r="2.2" fill="#EF4444" /> : null)}
        </svg>
    );
}
